import React, { Component } from 'react';
import { Box, Button, Card, CardActionArea, CardMedia, CardContent, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import samplePosts from './samplePosts';
import fallbackImage from '../../assets/background.jpg';

class LatestPosts extends Component {
    normalizePosts = (posts) => {
        if (!Array.isArray(posts)) {
            return [];
        }
        return posts.map((post, index) => ({
            ...post,
            id: post.id ?? index + 1,
            image: post.image || post.photo_link || '',
            short: post.short || post.summary || '',
            title: post.title || post.short || 'Untitled Post',
        }));
    };

    render() {
        const { latestPosts } = this.props;
        const normalizedLatest = this.normalizePosts(latestPosts);
        const resolvedPosts = normalizedLatest.length > 0
            ? normalizedLatest
            : this.normalizePosts(samplePosts).slice(0, 3);

        // Check if latestPosts is undefined or null
        if (!resolvedPosts || resolvedPosts.length === 0) {
            return null; // Or you can render a loading spinner or message here
        }

        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, alignItems: 'center' }}>
                <Typography variant="h4" color="white" sx={{ textAlign: 'center' }}>
                    Latest From Our Blog
                </Typography>
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
                    {resolvedPosts.map((post, index) => {
                        const postLink = `/blog/${post.category}/${post.slug}`;
                        return (
                        <Card key={post.id || post.slug || index} sx={{ width: 300, borderRadius: '20px', bgcolor: 'rgba(0,0,0,0.6)', border: '1px solid rgba(255,255,255,0.2)' }}>
                            <CardActionArea component={Link} to={postLink}>
                                <CardMedia
                                    component="img"
                                    height="140"
                                    image={post.image || fallbackImage}
                                    alt={post.title}
                                    onError={(event) => { event.target.src = fallbackImage; }}
                                />
                                <CardContent>
                                    <Typography  variant="h5" fontFamily='Pt Mono' color='white' fontSize='1rem' component="div">
                                        {post.title}
                                    </Typography>
                                    <Typography  variant="h5" fontFamily='Pt Mono' color='white' fontSize='1rem' component="div">
                                        {post.category}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    )})
                    }
                </Box>
                <Button
                    component={Link}
                    to="/blog"
                    variant="outlined"
                    sx={{
                        color: 'white',
                        borderColor: 'white',
                        fontFamily: 'PT Mono, monospace',
                        fontWeight: 'bold',
                        borderRadius: '10px',
                        '&:hover': { borderColor: 'white', opacity: 0.9 },
                    }}
                >
                    READ ALL POSTS
                </Button>
            </Box>
        );
    }
}

export default LatestPosts;
